enum BulkEmailType {
    FRANCHISEES = 'franchisees',
    MEMBERS = 'members',
    CERTIFICATES_TO_MEMBERS = 'certificates_to_members',
    SCHOOLS = 'schools'
}

export {
    BulkEmailType
}